import { DestroyRef, EnvironmentProviders, inject, makeEnvironmentProviders, provideAppInitializer } from '@angular/core';
import { Event, NavigationEnd, NavigationError, Router } from '@angular/router';
import { filter, Observable, skipUntil, Subscription, take } from 'rxjs';

const CHUNK_LOAD_ERROR_NAME = 'ChunkLoadError';

export function provideChunkReload(assign: (url: string) => void = (url) => window.location.assign(url)): EnvironmentProviders {
    return makeEnvironmentProviders([
        provideAppInitializer(() => {
            const subscription = reloadOnMissingChunk(inject(Router).events, assign);
            inject(DestroyRef).onDestroy(() => subscription.unsubscribe());
        })
    ]);
}

export function reloadOnMissingChunk(events: Observable<Event>, assign: (url: string) => void): Subscription {
    // A freshly loaded page already belongs to the deployed release, so a reload cannot fix a chunk missing during
    // its initial navigation. Ignoring those failures also rules out a reload loop.
    const firstNavigationEnd = events.pipe(
        filter((event) => event instanceof NavigationEnd),
        take(1)
    );
    return events
        .pipe(
            skipUntil(firstNavigationEnd),
            filter((event): event is NavigationError => event instanceof NavigationError && isChunkLoadError(event.error))
        )
        .subscribe((event) => assign(new URL(event.url.replace(/^\//, ''), document.baseURI).href));
}

function isChunkLoadError(error: unknown): boolean {
    return error instanceof Error && error.name === CHUNK_LOAD_ERROR_NAME;
}
